import { Utils } from 'versafleet-core';

const { Helper, ReduxHelper } = Utils;

const initialState = {
  timestamp: null,
  archivedTimestamp: null,
  jobs: {},
  jobsIds: [],
  archivedJobIds: [],
  jobMeta: {},
  archivedJobMeta: {},
  filter: {},
  error: {},
  eventType: '',
  importError: [],
};

function job(state = initialState, action) {
  switch (action.type) {
    case 'RESET_JOB_IMPORT_ERROR':
      return {
        ...state,
        importError: [],
      };
    case 'RECEIVE_JOB':
      return {
        ...state,
        jobs: ReduxHelper.mergeDataWithObject(state.jobs, action.job),
      };
    case 'RECEIVE_JOBS':
      if (Helper.isNullOrUndefined(state.timestamp) || state.timestamp < action.timestamp) {
        return {
          ...state,
          jobsIds: action.jobs.map(j => j.id),
          jobs: ReduxHelper.mergeDataWithList(state.jobs, action.jobs),
          jobMeta: action.meta,
          timestamp: action.timestamp,
        };
      }
      return state;
    case 'RECEIVE_ARCHIVED_JOBS':
      if (Helper.isNullOrUndefined(state.archivedTimestamp)
        || state.archivedTimestamp < action.timestamp) {
        return {
          ...state,
          archivedJobIds: action.jobs.map(j => j.id),
          jobs: ReduxHelper.mergeDataWithList(state.jobs, action.jobs),
          archivedJobMeta: action.meta,
          archivedTimestamp: action.timestamp,
        };
      }
      return state;
    case 'RECEIVE_JOB_UPDATE_SUCCESSFUL':
      return {
        ...state,
        jobs: ReduxHelper.mergeDataWithObject(state.jobs, action.job),
      };
    case 'RECEIVE_JOB_EXPORT_SUCCESSFUL':
      return {
        ...state,
        isUpdating: false,
      };
    case 'RECEIVE_JOB_IMPORT_SUCCESSFUL':
      return {
        ...state,
        importError: [],
        eventType: 'import',
        isUpdating: false,
      };
    case 'RECEIVE_JOB_IMPORT_FAILED':
      return {
        ...state,
        importError: action.error,
        isUpdating: false,
      };
    case 'RECEIVE_EXPORT_TASK_COUNT_SUCCESSFUL':
      return {
        ...state,
        taskCount: action.taskCount,
        error: {},
        isUpdating: false,
      };
    case 'RECEIVE_RESET_JOB_EXPORT_TASK_COUNT':
      return {
        ...state,
        taskCount: null,
      };
    case 'SET_JOB_FILTER':
      return {
        ...state,
        filter: action.filter || state.filter,
      };
    default:
      return state;
  }
}

export default job;
